var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlutterwave(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 176 144.7",
    width: 19.7,
    height: 24,
    style: {
      enableBackground: "new 0 0 176 144.7"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:#009A46;}\n\t.st1{fill:#FF5805;}\n\t.st2{fill:#F5AFCB;}\n\t.st3{fill:#FF9B00;}\n ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,31.6c0-9.4,2.7-17.4,8.5-23.1l10,10C7.4,29.6,17.1,64.1,48.8,95.8s66.2,41.4,77.3,30.3l10,10 c-18.8,18.8-61.5,5.4-97.3-30.3C14,80.9,0,52.8,0,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,144.7c-9.4,0-17.4-2.7-23.1-8.5l10-10c11.1,11.1,45.6,1.4,77.3-30.3s41.4-66.2,30.3-77.3l10-10 c18.8,18.8,5.4,61.5-30.3,97.3C112.4,130.7,84.2,144.7,63.1,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.5,91.6c-6.1-17.5-18.5-36.2-34.9-52.6C69.8,3.2,27.1-10.1,8.3,8.6l0,0C7,10,8.2,13.3,10.9,16 s6.1,3.9,7.4,2.6c11.1-11.1,45.6-1.4,77.3,30.3c15,15,26.2,31.8,31.6,47.3c4.7,13.6,4.3,24.6-1.2,30.1l0,0 c-1.3,1.3-0.2,4.6,2.6,7.4s6.1,3.9,7.4,2.6C145.6,126.6,147.2,110.7,140.5,91.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M167.5,8.6C157.9-1,142-2.6,122.9,4c-17.5,6.1-36.2,18.5-52.6,34.9c-35.8,35.8-49.1,78.5-30.3,97.3l0,0 c1.3,1.3,4.7,0.2,7.4-2.6s3.9-6.1,2.6-7.4c-11.1-11.1-1.4-45.6,30.3-77.3c15-15,31.8-26.2,47.2-31.6c13.6-4.7,24.6-4.3,30.1,1.2 l0,0c1.3,1.3,4.6,0.2,7.4-2.6S168.9,10,167.5,8.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutterwave);
export default __webpack_public_path__ + "static/media/flutterwave.6a206fa13395ffb84c186b0e7a3a5912.svg";
export { ForwardRef as ReactComponent };